jQuery(function($) {
  let $wheel_triggers = $('#js-wheel-svg a');

  function hideStateHeader() {
    $('.state-info .state-info-header').css('display', 'none');
  }

  //For whatever reason hover effects are not being applied in safari

  function hoverRing(anchor) {
    //Text colors
    anchor.find('.innertext').css('fill', '#fff');
    anchor.find('text').css('fill', '#fff');

    // Rings
    anchor.find('.ring1, .ring2, .ring3, .ring4').css('fill', '#278acc');

    //Wedges
    anchor.find('.greenwedge').css('fill', '#679903');
    anchor.find('.yellowwedge').css('fill', '#d3a904');
    anchor.find('.orangewedge').css('fill', '#d16200');

    //Center
    anchor.find('.centercircle').css('fill', 'rgb(90, 90, 90)');
  }

  function unhoverRing(anchor) {
    anchor.removeClass('hovered');
    //Reset Text colors
    anchor.find('.innertext').css('fill', '#000');
    anchor.find('text').css('fill', '#000');

    //Rings
    anchor.find('.ring1').css('fill', '#d8ebf3');
    anchor.find('.ring2').css('fill', '#a3cde6');
    anchor.find('.ring3').css('fill', '#6fb1da');
    anchor.find('.ring4').css('fill', '#3c95cf');

    // Wedges
    anchor.find('.greenwedge').css('fill', '#85bc17');
    anchor.find('.yellowwedge').css('fill', '#ffcc02');
    anchor.find('.orangewedge').css('fill', '#ff7801');

    //Center
    anchor.find('.centercircle').css('fill', '#fff');
  }

  $wheel_triggers.focusin(function() {
    hoverRing($(this));
  }).focusout(function() {
    unhoverRing($(this));
  });

  $wheel_triggers.mouseenter(function() {
    hoverRing($(this));
  }).mouseleave(function() {
    unhoverRing($(this));
  });

  $wheel_triggers.click(function() {
    hideStateHeader();
    // $wheel_cards.removeClass('active');
    let $card_id = $(this).attr('href');
    // $($card_id).addClass('active');
    window.location = $card_id;
  });

  $('#js-wheel-state').change(function() {
    hideStateHeader();
    // $wheel_cards.removeClass('active');
    let $selected_state = $('#js-wheel-state option:selected').val();
    window.location = $selected_state;
  });

});
